import React from "react";
import INFO from "../../data/user";

const Footer = () => {
	return (
		<footer className="relative bg-lab-ink text-lab-paper border-t border-lab-rule-strong">
			<div className="max-w-[1400px] mx-auto px-6 md:px-10 py-10">
				<div className="grid grid-cols-12 gap-6 font-mono text-[11px] tracking-widest uppercase text-lab-paper-dim">
					<div className="col-span-6 md:col-span-3">
						<div>Entity</div>
						<div className="text-lab-paper mt-1">Azerty Labs</div>
					</div>
					<div className="col-span-6 md:col-span-3">
						<div>Period</div>
						<div className="text-lab-paper mt-1 tabular-nums">2020–2022</div>
					</div>
					<div className="col-span-6 md:col-span-3">
						<div>Operator</div>
						<a
							href={INFO.socials.website.link}
							target="_blank"
							rel="noopener noreferrer"
							className="text-lab-paper mt-1 block hover:text-lab-accent transition-colors"
						>
							Chloé Lavrat
						</a>
					</div>
					<div className="col-span-6 md:col-span-3">
						<div>State</div>
						<div className="text-lab-accent mt-1">Archived</div>
					</div>
				</div>

				<div className="mt-10 pt-4 border-t border-lab-rule flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 font-mono text-[10px] tracking-widest uppercase text-lab-paper-dim">
					<span>© 2020–2022 Azerty Labs • preserved as archive</span>
					<span>v1.0 · {new Date().getFullYear()}</span>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
